import numeral from 'numeral'

const filters  =  {
    MoneyFilter: value =>
        value ? numeral(value).format('($0,0.00)') : '$0',
    MoneyFilterNoDecimals: value =>
        value ? numeral(value).format('($0,0)') : '$0',
    PercentFilter: value =>
        value ? `${Number(value).toFixed(2)}%` : '0%',
    StringFilter: value =>
        value ? value[0].toUpperCase() + value.slice(1).toLowerCase() : '',
    CapitalizeFilter: value =>
        value ? value.toLowerCase().replace(/(\w|[áÁéÉíÍóÓúÚ])\S*/g, (w) => (w.replace(/^(\w|[áÁéÉíÍóÓúÚ])/, (c) => c.toUpperCase()))) : '',
    DateFilter: function (value) {
        if (!value) return ''
        if (value == undefined) return ''
        let cadena = value.split('T')
        let lista = cadena[0].split('-')
        return lista[2] + '/' + lista[1] + '/' + lista[0]//T-15249 Error en fecha
    }
}
export default filters